import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MessageSquare, Clock } from 'lucide-react';
export function ContactUsPage() {
  return <main className="flex-1 bg-background" data-id="element-171">
      {/* Hero Section */}
      <section className="relative pt-16 pb-12 lg:pt-24 lg:pb-16 bg-gradient-to-br from-primary/5 to-accent/5" data-id="element-172">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-173">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold text-slate-dark mb-6" data-id="element-174">
            Contact Us
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-175">
            Have a question? We're here to help.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white" data-id="element-176">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-178">
            {/* Contact Info */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="space-y-8" data-id="element-179">
              <div data-id="element-180">
                <h2 className="text-2xl font-bold text-slate-dark mb-6" data-id="element-181">
                  Get in Touch
                </h2>
                <p className="text-slate-600 leading-relaxed mb-8" data-id="element-182">
                  Whether you have questions about our plans, need technical
                  support, or want to discuss business solutions, our team is
                  ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-183">
                <div className="flex items-start gap-4 p-4 rounded-lg bg-slate-50 border border-slate-100" data-id="element-184">
                  <Mail className="w-6 h-6 text-accent mt-1" data-id="element-185" />
                  <div data-id="element-186">
                    <h3 className="font-semibold text-slate-dark mb-1" data-id="element-187">
                      Email Support
                    </h3>
                    <a href="mailto:manishhoran123@gmail.com" className="text-primary hover:underline" data-id="element-188">
                      manishhoran123@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 rounded-lg bg-slate-50 border border-slate-100" data-id="element-189">
                  <Clock className="w-6 h-6 text-accent mt-1" data-id="element-190" />
                  <div data-id="element-191">
                    <h3 className="font-semibold text-slate-dark mb-1" data-id="element-192">
                      Response Time
                    </h3>
                    <p className="text-slate-600" data-id="element-193">
                      Our team responds within one working day.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white p-8 rounded-xl shadow-lg border border-slate-100" data-id="element-194">
              <h3 className="text-xl font-bold text-slate-dark mb-6 flex items-center gap-2" data-id="element-195">
                <MessageSquare className="w-5 h-5 text-primary" data-id="element-196" />
                Send us a message
              </h3>
              <form className="space-y-4" data-id="element-197">
                <div data-id="element-198">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-199">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-200" />
                </div>
                <div data-id="element-201">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-202">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-203" />
                </div>
                <div data-id="element-204">
                  <label htmlFor="subject" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-205">
                    Subject
                  </label>
                  <select id="subject" className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" data-id="element-206">
                    <option data-id="element-207">General Enquiry</option>
                    <option data-id="element-208">Support</option>
                    <option data-id="element-209">Billing</option>
                    <option data-id="element-210">Business Access</option>
                  </select>
                </div>
                <div data-id="element-211">
                  <label htmlFor="message" className="block text-sm font-medium text-slate-700 mb-1" data-id="element-212">
                    Message
                  </label>
                  <textarea id="message" rows={4} className="w-full px-4 py-2 rounded-lg border border-slate-300 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all" placeholder="How can we help?" data-id="element-213"></textarea>
                </div>
                <button type="submit" className="w-full bg-accent hover:bg-accent-dark text-white font-semibold py-3 rounded-lg transition-colors shadow-md hover:shadow-lg active:transform active:scale-95" data-id="element-214">
                  Send Message
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </main>;
}